<template>
  <div
    class="tab-pane fade"
    id="sum-age-content"
    role="tabpanel"
    aria-labelledby="sum-age-content-tab"
  >
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">遊客中心</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <!-- <option value="0">全部</option> -->

            <option
              v-for="(list, index) in peopleAnalysisScenicArea"
              :key="index"
              :value="list.id"
            >
              {{ list.name }}
            </option>
          </select>
        </div>

        <!-- <div class="col-md-3">
          <label for="inputEmail4" class="form-label">種類</label>
          <select class="form-control" id="SensorSN" name="SensorSN" v-model.number="selectType" disabled>
                      <option v-for="(type, index) in typeList" :key="index" :value="type.type">{{type.description}}</option>
                    </select>
        </div> -->

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="startTime"
            @focus="updateMaxSelectTime"
          >
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime
            input-class="form-control"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }"
            :minute-step="1"
            :max-datetime="maxSelectTime"
            :auto="true"
            v-model="endTime"
            @focus="updateMaxSelectTime"

          >
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button
            type="button"
            class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
            @click="queryElk"
            :disabled="isWaitResult"
          >
            <i class="fas fa-search"></i> 查詢
          </button>
          <button
            type="button"
            class="btn btn-primary btn-sm rounded-pill px-3 mx-1"
            @click="queryCSV"
            :disabled="isWaitResult"
          >
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px">年齡統計</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">
              <table
                id="sumAgeTable"
                class="w3-table-all table table-hover table-striped"
              >
                <thead class="table-dark">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">景區</th>

                    <th scope="col">孩童</th>
                    <th scope="col">青壯年</th>
                    <th scope="col">銀髮族</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, key) in peopleAnalysisDataList"
                    :key="key"
                    :class="tableCenterStyle"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.scenicAreaName }}</td>

                    <td>{{ item.childCount }} / {{ item.childRatio }} %</td>
                    <td>{{ item.adultCount }} / {{ item.adultsRatio }} %</td>
                    <td>{{ item.eldersCount }} / {{ item.eldersRatio }} %</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2 pt-4">
          <div style=" max-width: 320px; min-width: 270px;" class="m-auto">
          <div id="sumAgeChart">
            <apexchart
              type="donut"
              height="auto"
              :options="displaySetting"
              :series="chartData"
            ></apexchart>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from "../../utils/utils";
import CONST from "../../utils/const";
import exportCSV from "../../utils/exportCSV";
import ApexchartObject from "../../utils/apexchartObject/searchPeopleAttribute";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      selectType: 0,
      typeList: [
        { description: "年齡", type: CONST.PEOPLE_ATTRIBUTE_TYPE.AGE },
      ],
      peopleAnalysisDataList: [],
      chartData: [],
      displaySetting: ApexchartObject.sumAgeDonutOption,
      chartSetting: ApexchartObject.sumAgeDonutOption,
      chartZeroSetting: ApexchartObject.sumAgeZeroDonutOption,

      isWaitResult: false,
      maxSelectTime: Utils.getLastestTime(),
    };
  },
  computed: {
    // maxSelectTime() {
    //   return moment().startOf("m").toISOString();
    // },
    // ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


    peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(
        (s) =>
          s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE
      );
    },

    searchTime() {
      return `${moment(this.startTime).format("YYYY/MM/DD HH:mm")}~${moment(
        this.endTime
      ).format("YYYY/MM/DD HH:mm")}`;
    },

    searchAreaName() {
      const area = this.scenicAreaList.find(
        (s) => s.id === this.selectScenicAreaId
      );
      return area ? area.name : "";
    },
  },
  methods: {
    async queryCSV() {
      this.isWaitResult = true;
      const peopleAnalysisDataList = await this.searchData();
      if (Utils.isEmptyObject(peopleAnalysisDataList)) {
        return;
      }

      const csvContent = [["時間", "遊客中心", "孩童", "青壯年", "銀髮族"]];
      peopleAnalysisDataList.forEach((item) => {
        const row = [];

        row.push(item.time.replace(/\n/g, ''))
        row.push(item.scenicAreaName)
        // row.push(
        //   `${moment(item.startTime).format("YYYY-MM-DD")} ${moment(
        //     item.startTime
        //   ).format("HH")}~${moment(item.startTime).add(1, "h").format("HH")}`
        // );
        row.push(`${item.childCount} / ${item.childRatio}%`);
        row.push(`${item.adultCount} / ${item.adultsRatio}%`);
        row.push(`${item.eldersCount} / ${item.eldersRatio}%`);

        csvContent.push(row);
      });

      const fileName = `CSV_${moment(this.startTime).format(
        "YYYY/MM/DD HH:mm"
      )}_遊客統計年齡.csv`;
      exportCSV.genCSVFile(csvContent, fileName);
      this.isWaitResult = false;
    },

    async queryElk() {
      this.isWaitResult = true;
      this.peopleAnalysisDataList = await this.searchData();
      this.setChartData(this.peopleAnalysisDataList);
      this.updateTable();
      this.isWaitResult = false;
    },

    async searchData() {
      // if( this.selectScenicAreaId === -1 ) {
      //   alert('請選擇遊客中心')
      //   return
      // }

      if (Utils.isEmptyObject(this.startTime)) {
        alert("請選擇開始時間");
        return;
      }

      if (Utils.isEmptyObject(this.endTime)) {
        alert("請選擇結束時間");
        return;
      }

      const st = moment(this.startTime).startOf('minute').valueOf();
      const et = moment(this.endTime).startOf('minute').valueOf();

      const condition = {
        startTime: st,
        endTime: et,
        // startTime: "2022-12-16T00:00:00",
        // endTime: "2022-12-16T23:55:55",
        scenicAreaId: this.selectScenicAreaId,
        type: this.selectType,
      };
      if(this.selectScenicAreaId === -1){

        const areaId=  this.peopleAnalysisScenicArea.map((s) => s.id);
        // console.log("area",areaId)
        condition.scenicAreaId = areaId;
          // console.log("condition.areas",condition.areas);
          }

        if(this.selectScenicAreaId > -1) {
        condition.scenicAreaId= this.selectScenicAreaId
        }

      await this.$store.dispatch(
        "peopleAttribute/getPeopleAttributeListPerHour",
        condition
      );
      const result = this.$store.getters["peopleAttribute/getSearchAgePerHour"];
      const total = {
        time: "統計",
        scenicAreaName: "",
        childCount: 0,
        childRatio: 0,
        adultCount: 0,
        adultsRatio: 0,
        eldersCount: 0,
        eldersRatio: 0,
      };

      const dataList = result.map((e) => {
        e.time = `${moment(e.startTime).format("YYYY-MM-DD")} \n ${moment(
          e.startTime
        ).format("HH")}~${moment(e.startTime).add(1, "h").format("HH")}`;

        total.childCount = total.childCount + e.childCount;
        total.adultCount = total.adultCount + e.adultCount;
        total.eldersCount = total.eldersCount + e.eldersCount;
        return e;
      });

      const totalAge = total.childCount + total.adultCount + total.eldersCount;
      if (totalAge === 0) {
        total.childRatio = 0;
        total.adultRatio = 0;
        total.eldersRatio = 0;
        
      } else {
        total.childRatio = Math.round((total.childCount / totalAge) * 100);
        total.adultsRatio = Math.round((total.adultCount / totalAge) * 100);
        total.eldersRatio = Math.round((total.eldersCount / totalAge) * 100);

      }


      dataList.push(total);

      console.log(dataList);
      return dataList;
    },

    setChartData(dataList) {
      if (Utils.isEmptyObject(dataList)) {
        this.chartData = []
        this.chartSetting = ApexchartObject.sumAgeDonutOption
        return;
      }

      if (this.selectScenicAreaId > -1) {
        this.chartSetting.chart.toolbar.export.svg.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_年齡統計_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartSetting.chart.toolbar.export.csv.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_年齡統計_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartSetting.chart.toolbar.export.png.filename = `${Utils.getSingleScenicAreaNamebyId(
          this.selectScenicAreaId
        )}_年齡統計_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
      } else {
        this.chartSetting.chart.toolbar.export.svg.filename = `全景區_年齡統計_${moment(
          
        ).format("YYYY年MM月DD日_HH時mm分")}`;
        this.chartSetting.chart.toolbar.export.csv.filename = `全景區_年齡統計_${moment(
          
        ).format("YYYY年MM月DD日_HH時mm分")}`;
        this.chartSetting.chart.toolbar.export.png.filename = `全景區_年齡統計_${moment(
          
        ).format("YYYY年MM月DD日_HH時mm分")}`;
      }
      
      dataList = dataList.filter((data) => data.time !== "統計"); //移除最後一位的統計欄位
      this.chartData = [];

      const initValue = 0;
      const childCount = dataList.reduce((result, current, index) => {
        result = result + current.childCount;
        return result;
      }, initValue);

      const adultCount = dataList.reduce((result, current, index) => {
        result = result + current.adultCount;
        return result;
      }, initValue);

      const eldersCount = dataList.reduce((result, current, index) => {
        result = result + current.eldersCount;
        return result;
      }, initValue);

      let chartSetting = {};
      if (childCount === 0 && adultCount === 0 && eldersCount === 0) {
        this.chartData = [20, 20, 20];
   

        this.chartZeroSetting.plotOptions.pie.donut.labels.total.formatter = function (val) {
          return "0";
        };
        this.chartZeroSetting.plotOptions.pie.donut.labels.value.formatter = function (val) {
          return "0";
        };

        this.chartZeroSetting.dataLabels.formatter = function (value, { seriesIndex, dataPointIndex, w }) {
            return  "0 %";
          };
          
        this.chartZeroSetting.tooltip.y.formatter = function (val) {
          return "0人";
        };

        this.chartZeroSetting.events = null;
        chartSetting = { ...this.chartZeroSetting };
      } else {
        this.chartData = [childCount, adultCount, eldersCount];
        chartSetting = { ...this.chartSetting };
      }

      
      this.displaySetting = { ...chartSetting }; // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    getTime: function (item) {
      if (Utils.isEmptyObject(item.startTime)) {
        return "-";
      }

      const time = moment(item.startTime);
      return `${time.format("YYYY/MM/DD")}`;
    },

    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    initTable: function () {
      this.table = $("#sumAgeTable").DataTable({
        aoColumns: [
          ...new Array($("#sumAgeTable th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url: "/json/dataTableZHTW.json",
        },
        pageLength: 32,
      });
    },

    updateTable() {
      if (!Utils.isEmptyObject(this.table)) {
        this.table.destroy();
      }

      setTimeout(() => {
        this.initTable();
      }, 100);
    },
  },
  mounted() {
    this.updateTable();
  },
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}

select:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th {
  width: 100%;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
} /* td自動斷行 */
table {
  table-layout: fixed;
  word-break: break-all;
} /* table不超過div */
</style>
